import React, { useContext, useEffect, useState } from "react";
import { ECLLoader } from "../../../index";
import useSelectorId from "../../../../utilities/hooks/useSelectorId";
import { ToastContext } from "../../../../utilities/contexts";
import "./ECLGauge.css";

//ECLGauge
//DATA:
//    -minVal: number for minimum value
//    -currentVal: number for current value
//    -maxVal: number for maximum value
//Draw Data:
//    -left_label: labels left side of gauge
//    -right_label: labels right side of gauge

export default function ECLGauge(props) {
   const gaugeId = useSelectorId();
   const [minVal, setMinVal] = useState(null);
   const [maxVal, setMaxVal] = useState(null);
   const [currentVal, setCurrentVal] = useState(null);
   const [drawData, setDrawData] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   const addToast = useContext(ToastContext);

   useEffect(() => {
      props
         .loader()
         .then((res) => {
            setMinVal(res.min_val);
            setCurrentVal(res.current_val);
            setMaxVal(res.max_val);
            setDrawData(res.drawData);
            setLoading(false);
         })
         .catch((error) => {
            //error handling here
            console.error(error);
            setError("Visualization request failed");
            addToast("Visualization request failed", "error");
         });
   }, [props.loader]);

   if (loading || error) {
      return <ECLLoader message={error} />;
   }

   //Are any of our values NaN?  are any of our values Null?
   if (
      !(isNaN(maxVal) || isNaN(minVal) || isNaN(currentVal)) &&
      maxVal !== null &&
      minVal !== null &&
      currentVal !== null
   ) {
      const valueToTotalRatio =
         ((currentVal - minVal) / (maxVal - minVal)) * 100;
      return (
         <div className="ecl-gauge">
            <div className="gauge-labels-div">
               <label
                  htmlFor={"current-val" + gaugeId}
                  className="gauge-label left"
               >
                  {drawData.left_label}
               </label>
               <label
                  htmlFor={"max-val" + gaugeId}
                  className="gauge-label right"
               >
                  {drawData.right_label}
               </label>
            </div>
            <div className="gauge-values-div">
               <p
                  id={"current-val" + gaugeId}
                  className={
                     currentVal >= maxVal
                        ? "gauge-value full-gauge-text"
                        : "gauge-value left"
                  }
               >
                  {currentVal.toFixed(2)}
               </p>
               <p
                  id={"max-val" + gaugeId}
                  className={
                     currentVal >= maxVal
                        ? "gauge-value full-gauge-text"
                        : "gauge-value"
                  }
               >
                  {maxVal.toFixed(2)}
               </p>
            </div>
            <div className="gauge-container">
               <div className="total-gauge"></div>
               <div
                  className={
                     currentVal >= maxVal
                        ? "value-gauge full-gauge"
                        : "value-gauge"
                  }
                  style={{ width: `${valueToTotalRatio}%` }}
               ></div>
            </div>
         </div>
      );
   }
   return <ECLLoader message={"Invalid value used"} />;
}
